import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b10885f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "count" }
const _hoisted_2 = { class: "param-content" }
const _hoisted_3 = { class: "action-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_NorthIcon = _resolveComponent("NorthIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_SouthIcon = _resolveComponent("SouthIcon")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_OptionTable = _resolveComponent("OptionTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.params, (row, rowIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: rowIndex,
        class: "param-block"
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(rowIndex + 1), 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FormField, {
            value: row.name,
            "onUpdate:value": ($event: any) => ((row.name) = $event),
            label: "Название параметра",
            name: `[${rowIndex}][name]`,
            class: "field"
          }, null, 8, ["value", "onUpdate:value", "name"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BaseButton, {
              variant: "icon",
              title: "Move up",
              disabled: rowIndex === 0,
              onClick: ($event: any) => (_ctx.handleClick(_ctx.params, rowIndex, 'up'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_NorthIcon)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]),
            _createVNode(_component_BaseButton, {
              variant: "icon",
              title: "Move down",
              disabled: rowIndex === _ctx.params.length - 1,
              onClick: ($event: any) => (_ctx.handleClick(_ctx.params, rowIndex, 'down'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SouthIcon)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]),
            _createVNode(_component_BaseButton, {
              variant: "icon",
              title: "Delete",
              disabled: !row.canDelete,
              onClick: ($event: any) => (_ctx.removeField(rowIndex))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DeleteIcon)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ]),
          _createVNode(_component_OptionTable, {
            options: row.options
          }, null, 8, ["options"])
        ])
      ]))
    }), 128))
  ]))
}